import BaseBean from "@/utils/BaseBean";

export interface IServiceStationCardDataObj {
    utilInst:ServiceStationCardUtil
    formRef:any
    disabled:boolean
    refMap:Map<string,any>
    compParams: any
    form:any
    rules:TFormRule
}
export default class ServiceStationCardUtil extends BaseBean{
    public dataObj:IServiceStationCardDataObj;

    constructor(proxy:any,dataObj:IServiceStationCardDataObj) {
        super(proxy);
        this.dataObj=dataObj
    }
    //构建下拉数据
    public async buildSelectData():Promise<void>{
        //构建网点下拉数据
        //this.dataObj.networkData=await this.utils.Api.buildNetworkData();
    }
    //停用启用user
    public changeStatus(params:any):void{
        this.utils.Tools.configBox({
            message:'确定要执行该操作吗?',
            sureFn:async ()=> {
                let url = this.dataObj.compParams.modelPath + "/custom";
                let res = await this.utils.Api.postRequest({ url: url, params: params});
                if(res.result){
                    this.utils.Tools.success({ message: res.msg });
                    if (this.proxy.engine.engineParams.ownerComp && this.proxy.engine.engineParams.ownerComp.queryHandler) this.proxy.engine.engineParams.ownerComp.queryHandler();
                    await this.proxy.engine.engineUtil.doAddOrLoad(this.proxy.engine.id);
                }
            }
        });
    }
    //重置密码
    public resetPwd():void{
        this.utils.Tools.configBox({
            message:'确定要执行该操作吗?',
            sureFn:async ()=> {
                let url = this.dataObj.compParams.modelPath + "/custom";
                let params={id:this.dataObj.form.id,operateType:'resetPwd'}
                let res = await this.utils.Api.postRequest({ url: url, params: params});
                if(res.result)
                this.utils.Tools.success({ message: res.msg });
            }
        });
    }
}